import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

const ExchangePassiveStatus = ({ data: { isPassive } }) => (
  <div className={classNames(styles.status, { [styles.status_passive]: isPassive })} />
);

export { ExchangePassiveStatus };
